import liCSS from 'components/Shared/MakeModelMenu/liCSS';
import { colors } from 'components/styles/variables';
import { useTranslation } from 'react-i18next';
import Model from 'types/Model';
import useEvents from 'lib/hooks/useEvents';
import { ModelTap } from 'lib/Tracking/MakeModelMenu/MakeModelMenuEvents';
import { useContext } from 'react';
import { FilterEventContext } from 'contexts/FilterEventContext';

type DisabledProp = (model: Model) => boolean;

interface ModelListResultsProps {
  models: Model[];
  disabled?: DisabledProp;
  choose: (value: Model) => void;
}

interface ResultProps {
  model: Model;
  disabled?: DisabledProp;
  choose: (value: Model) => void;
}

function Result({ model, disabled, choose }: ResultProps): JSX.Element {
  const { t } = useTranslation();
  const logger = useEvents();
  const filterEventContext = useContext(FilterEventContext);

  const handleClick = (): void => {
    logger.log(ModelTap(filterEventContext));
    if (choose) choose(model);
  };

  let isDisabled = false;
  if (disabled) {
    isDisabled = disabled(model);
  }
  return (
    <li
      key={model.name}
      data-model={model.name}
      className={
        isDisabled
          ? 'make-model-menu-model-list-results-item --disabled'
          : 'make-model-menu-model-list-results-item'
      }
      onClick={handleClick}
    >
      <div className="name">{model.name}</div>
      <div className="badge">{t('contentDashboard.notEnoughData')}</div>
      <style jsx>{liCSS}</style>
      <style jsx>{`
        .make-model-menu-model-list-results-item {
          display: flex;
          align-items: center;
          padding-left: 24px;
        }
        .name {
          font-size: 14px;
          line-height: 20px;
        }
        .badge {
          display: none;
          font-size: 9px;
          color: white;
          background-color: ${colors.G2};
          border-radius: 10px;
          position: relative;
          text-transform: uppercase;
          font-weight: 600;
          padding: 4px 10px;
          top: 1px;
          left: 10px;
        }
        .make-model-menu-model-list-results-item.--disabled {
          color: ${colors.G2};
          cursor: not-allowed;
        }
        .make-model-menu-model-list-results-item.--disabled .badge {
          display: inline-block;
        }
      `}</style>
    </li>
  );
}

function ModelListResults({ models, disabled, choose }: ModelListResultsProps): JSX.Element {
  return (
    <>
      {models.map((model) => (
        <Result model={model} key={model.name} choose={choose} disabled={disabled} />
      ))}
      <style jsx>{liCSS}</style>
      <style jsx>
        {`
          .make-model-menu-models-list {
            margin: 0;
            padding: 0;
          }
        `}
      </style>
    </>
  );
}

export default ModelListResults;
